import React from 'react';

import { Text } from '@/components/TextComponent';
import { Box, Column, Row } from '@/components/lib/components';
import { getTeamDisplayName, getTeamOrder } from '@/utils/sport-utils';

import { Event, Market } from '../../types';
import { groupSetBettingOptions } from '../../utils/set-betting';
import { OptionButton, getBorderRadiusStyle } from '../OptionButton';

type ColumnStackMarketProps = {
    markets: Array<Market>;
    event: Event;
    testID?: string;
};

const COLUMNS = 2;

export const ColumnStackMarket = ({ markets, event, testID }: ColumnStackMarketProps) => {
    const market = markets[0];
    const sportName = event.sport.name;
    const optionsBySide = groupSetBettingOptions(market?.options ?? []);

    if (!market || (!optionsBySide.home.length && !optionsBySide.away.length)) {
        return null;
    }

    return (
        <Row gap="s3">
            {getTeamOrder(sportName).map((side, columnIndex) => {
                const team = side === 'home' ? event.home_team : event.away_team;
                const options = optionsBySide[side];
                return (
                    <Column key={side} flex={1}>
                        <Box marginBottom="s12">
                            <Text variant="bodySmall" color="neutral300" textAlign="center" numberOfLines={1}>
                                {getTeamDisplayName(team, sportName)}
                            </Text>
                        </Box>
                        <Column gap="s3">
                            {options.map((option, rowIndex) => (
                                <OptionButton
                                    key={option.id}
                                    option={option}
                                    market={market}
                                    event={event}
                                    testID={testID}
                                    isShortName
                                    buttonStyle={getBorderRadiusStyle(rowIndex, columnIndex, options.length, COLUMNS)}
                                />
                            ))}
                        </Column>
                    </Column>
                );
            })}
        </Row>
    );
};
